<span [ngStyle]="{'color': color}">{{ value || '' }}</span>
